import { ReactComponent as PreloaderIcon } from 'assets/icons/preloader.svg';
import { cn } from 'lib/utils';

import './style.scss';

export enum RyeLogoSizeClass {
  small = 'small-preloader',
  micro = 'micro-preloader',
}

interface RyeLogoProps {
  size?: RyeLogoSizeClass;
}

const RyeLogo = ({ size }: RyeLogoProps) => {
  return <PreloaderIcon className={cn('preloader', size)} />;
};

export default RyeLogo;
